/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

export function textMapper(requestValue) {
  return String(requestValue);
}
